$(function() {

    $('select[data-another-city]').change(function(e) {

        let val = $(this).val();
        let input = $(this).parents('form').find('input[data-another-city]');

        if (val == -1) {
            $(this).parent().hide();
            $(this).removeAttr('required');
            input.parent().show();
            input.attr('required', '');
        }

    });

});